import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetOnePlayable(data = {}) {
  const { enabled = false, configs = {}, podcastId, episodeId, playableId } = data;

  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getOnePlayable() {
    return privateFetch
      .get(`/v1/admin/podcast/${podcastId}/episode/${episodeId}/playable/${playableId}`, configs)
      .then((res) => res.data);
  }

  return useQuery(['podcast-playable-getResource', params], getOnePlayable, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetOnePlayable;
